import { EMPTY_GUID } from "./../../../../../../apps/resource-portal/src/app/constants/app.constant";
import { takeUntil, Subject } from "rxjs";
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { ReportService } from "apps/resource-portal/src/app/services/report.service";

@Component({
  selector: "concourse-dynamic-dropdown",
  templateUrl: "./dynamic-dropdown.component.html",
  styleUrls: ["./dynamic-dropdown.component.scss"],
})
export class DynamicDropdownComponent implements OnInit, OnDestroy, OnChanges {
  $unsubscribe = new Subject<void>();
  @Input() projectId;
  @Input() filter;
  @Input() datatype;
  @Input() reference;
  showAll: boolean = false;
  options = [];
  emptyGuid = EMPTY_GUID;
  selectedValue: any = []; // changed to array for multi-select

  fetchXML = "";
  filterCondition = "";

  @Output("onDropdownChange") dropdownChange = new EventEmitter();
  constructor(public _reportService: ReportService) { }

  async ngOnChanges(): Promise<void> {
    if (this.filter && this.filter?.allowall) {
      this.showAll = JSON.parse(this.filter?.allowall.toLowerCase());
    }
    this.copyQueries();
    if (
      this.reference &&
      this.reference.filtervalue != this.emptyGuid &&
      Number(this.reference.orderno) + 1 == Number(this.filter.orderno)
    ) {
      this.filterCondition = this.filterCondition.replace(
        "{0}",
        this.reference.filtervalue
      );
      this.fetchXML = this.fetchXML.replace("{0}", this.filterCondition);
      // console.log('fetchXML==>', this.fetchXML);
      // console.log('condition==>', this.filterCondition);


      this.options = await this.executeFilter(this.fetchXML);
      if (this.options.length) {
        // Auto-select first option if reference filter updates
        if (this.datatype == 6) {
          this.selectedValue = [this.options[0]];
        } else {
          console.log(this.showAll, this.filter.displayname);

          if (this.showAll) {
            this.selectedValue = this.emptyGuid;
          } else {
            this.selectedValue = this.options[0].id;
          }
        }
        this.onSelectionChange(this.selectedValue);
      }
    }
    if (
      this.reference &&
      this.reference.filtervalue == this.emptyGuid &&
      Number(this.reference.orderno) + 1 == Number(this.filter.orderno)
    ) {
      this.options = [];
      if (this.datatype != 6 && this.showAll) {
        this.selectedValue = this.emptyGuid;
        this.onSelectionChange(this.selectedValue);
      }
    }
  }

  async ngOnInit(): Promise<void> {
    this.copyQueries();

    if (this.filter && this.filter?.orderno == "1") {
      if (this.filter.filtercondition) {
        this.fetchXML = this.fetchXML.replace("{0}", this.filter.filtercondition);
      } else {
        this.fetchXML = this.fetchXML.replace("{0}", this.projectId);
      }

      this.options = await this.executeFilter(this.fetchXML);

      // Auto-select based on projectId if found
      const selectedOption = this.options.find(o => o.id === this.projectId);
      if (selectedOption) {
        if (this.datatype == 6) {
          this.selectedValue = [selectedOption];
        } else {
          this.selectedValue = selectedOption.id;
        }
        this.onSelectionChange(this.selectedValue);
      } else {
        console.log(this.showAll, this.filter.displayname);

        if (this.datatype != 6 && this.showAll) {
          this.selectedValue = this.emptyGuid;
          this.onSelectionChange(this.selectedValue);
        } else if (this.datatype != 6 && this.options.length) {
          this.selectedValue = this.options[0].id;
          this.onSelectionChange(this.selectedValue);
        }
      }
    }
  }

  copyQueries() {
    this.fetchXML = this.filter.fetxml;
    this.filterCondition = this.filter.filtercondition;
  }

  async executeFilter(fetchXML): Promise<any[]> {
    fetchXML = fetchXML.replace("{UserId}", JSON.parse(localStorage.getItem('user')).contact_id);
    return new Promise((resolve, reject) => {
      this._reportService
        .getExecutedData(fetchXML)
        .pipe(takeUntil(this.$unsubscribe))
        .subscribe((result) => {
          return resolve(result);
        });
    });
  }

  onSelectionChange(selection) {
    // selection is now an array of objects (because bindValue is not set, it returns the whole object)
    // OR array of IDs if bindValue is set.
    // In the HTML, [bindLabel]="'name'" is used, no bindValue, so it returns objects.
    // But wait, user requested "comma separated ids". 
    // And in the old code `selectedValue` was bound to `option.id` in standard select.

    // Let's bind 'id' in the HTML, or map it here.
    // If we receive an array of objects:
    let selectedIds = "";
    let selectedNames = "";

    // IMPORTANT: Ignore native DOM Event objects that bubble up from inner checkboxes
    if (selection instanceof Event) {
      return;
    }

    if (typeof selection === 'string') {
      if (selection === this.emptyGuid) {
        selectedIds = this.emptyGuid;
        selectedNames = "All";
      } else {
        const selectedOption = this.options.find(o => o.id === selection);
        if (selectedOption) {
          selectedIds = selectedOption.id;
          selectedNames = selectedOption.name;
        }
      }
    } else if (Array.isArray(selection)) {
      selectedIds = selection.map(s => s.id).join(',');
      selectedNames = selection.map(s => s.name).join(',');
    } else if (selection && selection.id) {
      // Single selection case if multiple="false" (fallback)
      selectedIds = selection.id;
      selectedNames = selection.name;
    }

    this.dropdownChange.emit({
      filterid: this.filter.id,
      orderno: this.filter.orderno,
      filtervalue: selectedIds, // Emitting comma separated IDs
      filtername: selectedNames,
      datatype: this.filter.datatype,
    });
  }

  getOptionNameById(id) {
    if (this.options && this.options.length) {
      return (
        this.options.find((o) => {
          return o.id == id;
        })?.name || "All"
      );
    }
    return "";
  }

  toggleSelectAll(type: string, event: any) {
    if (event.target.checked) {
      this.selectedValue = [...this.options];
    } else {
      this.selectedValue = [];
    }
    this.onSelectionChange(this.selectedValue);
  }

  isAllSelected(type: string) {
    return this.options.length > 0 && this.selectedValue?.length === this.options.length;
  }

  isSelected(type: string, item: any) {
    return this.selectedValue?.some((selected) => selected.id === item.id);
  }

  onCheckboxChange(type: string, item: any, event: any) {
    // This method is called when an individual checkbox in the dropdown is clicked.
    // However, ng-select handles the selection change automatically when the option is clicked.
    // Passing the event here might be redundant if we bind [(ngModel)]="selectedValue".
    // But if we want to manually handle it (e.g. to stop propagation or custom logic):

    let currentSelected = this.selectedValue || [];
    if (event.target.checked) {
      if (!this.isSelected(type, item)) {
        this.selectedValue = [...currentSelected, item];
      }
    } else {
      this.selectedValue = currentSelected.filter(s => s.id !== item.id);
    }
    this.onSelectionChange(this.selectedValue);
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
